var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMapClusterMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#346DCD",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.4,
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1A396F",
    cx: 16,
    cy: 16,
    r: 10.435
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMapClusterMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-map-cluster-marker.469e8641107a46a2e536c0864a95a322.svg";